export default "__VITE_ASSET__hlGJpoWB__"